import { useCallback, useEffect, useRef } from 'react';
import { SwiperRef } from 'swiper/react';

const usePhotoGallery = (selectedPhotoIndex?: number) => {
  const ref = useRef<SwiperRef>(null);

  useEffect(() => {
    let swiperInstance: SwiperRef['swiper'] | null = null;

    const handleSlideChange = (swiper: SwiperRef['swiper']) => {
      scrollToPhoto(swiper.realIndex);
    };

    const timeoutId = setTimeout(() => {
      if (!ref.current) return;

      if (selectedPhotoIndex !== undefined) {
        scrollToPhoto(selectedPhotoIndex);
      }

      swiperInstance = ref.current.swiper;
      swiperInstance.on('slideChange', handleSlideChange);
    }, 1000);

    return () => {
      clearTimeout(timeoutId);
      swiperInstance?.off('slideChange', handleSlideChange);
    };
  }, []);

  const scrollToPhoto = useCallback((index: number) => {
    const selectedPhotoBullet = document.getElementsByClassName(
      getPhotoBulletClass(index)
    )?.[0];

    if (!selectedPhotoBullet) return;

    selectedPhotoBullet.scrollIntoView({
      behavior: 'instant',
      block: 'end',
    });
  }, []);

  const getPhotoBulletClass = useCallback(
    (index: number) => `photo-bullet-${index}`,
    []
  );

  const zoomIn = useCallback(() => {
    if (ref.current) ref.current.swiper.zoom.in();
  }, [ref.current]);

  const zoomOut = useCallback(() => {
    if (ref.current) ref.current.swiper.zoom.out();
  }, [ref.current]);

  return {
    ref,
    zoomIn,
    zoomOut,
    getPhotoBulletClass,
  };
};

export default usePhotoGallery;
